//
let counter = 0;
let showLoader : Function | null = null;

export default function( setShowLoader:any ){
    showLoader = setShowLoader;
}

export function addRequest(){
    counter++;
    checkCloseLoader();
}

export function closeRequest(){
    counter--;
    checkCloseLoader();
}

export function closeAllRequest(){
    counter=0;
    checkCloseLoader();
}

export function isLoading(){
    return counter > 0;
}

function checkCloseLoader(){
    showLoader = showLoader as Function
    if( counter == 0 ){
        showLoader(false)
    } else if(counter < 0 ){
        showLoader(false)
        counter = 0;
    }else{
        showLoader(true)
    }
}

